import { ReactNode } from "react";
import { useGetContactInfo } from "api/common/useGetContactInfo";
import { LoadingIndicator } from "components";
import { useGetContractIdData } from "providers/ContractIdProvider";
import { NoPortfolios } from "./components/NoPortfolios";

interface PortfolioGuardProps {
  children: ReactNode;
}

export const PortfolioGuard = ({ children }: PortfolioGuardProps) => {
  const { selectedContactId } = useGetContractIdData();
  const { data: { portfolios } = { portfolios: [] }, loading } =
    useGetContactInfo(false, selectedContactId);

  // While the (new) contact's portfolios are still loading, show a spinner
  // instead of briefly flashing the "no portfolios" message.
  if (loading) {
    return <LoadingIndicator center />;
  }

  if (portfolios.length === 0) {
    return <NoPortfolios />;
  }

  return <>{children}</>;
};
